<template>
  <MeasureContainer />
</template>

<script lang="ts">
import Vue from "vue";
import MeasureContainer from "@/components/measures/measure/container/MeasureContainer.vue";

export default Vue.extend({
  components: {
    MeasureContainer,
  },
});
</script>
